import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@7f-ui/components/accordion/accordion';
import { Dog, Wheelchair } from '@phosphor-icons/react';
import type { PaxPickerAccommodation } from './pax-modal-content';
type Props = {
  accommodation: PaxPickerAccommodation;
};
export function PaxContactInfos(t0) {
  const $ = _c(11);
  const {
    accommodation: t1
  } = t0;
  const {
    servicePhone,
    importantNotes
  } = t1;
  if (!servicePhone) {
    return null;
  }
  let t2;
  if ($[0] !== importantNotes) {
    t2 = importantNotes.find(_temp);
    $[0] = importantNotes;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const showBarrierFreeInfo = t2;
  const t3 = `tel:+49${servicePhone}`;
  let t4;
  if ($[2] !== servicePhone || $[3] !== t3) {
    t4 = <Accordion color="ghost" title="Du reist mit Hund?" Icon={Dog}>{"Dieses Hotel bietet Zimmer an, in denen Hunde willkommen sind. Diese werden \xFCber unser Service Center eingebucht. Ruf bitte unter folgender Telefonnummer an: "}<a className="text-link" href={t3}>{servicePhone}</a>.</Accordion>;
    $[2] = servicePhone;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== servicePhone || $[6] !== showBarrierFreeInfo) {
    t5 = showBarrierFreeInfo && <Accordion color="ghost" title="Barrierefreie Zimmer" Icon={Wheelchair}>{"Du kannst in diesem Hotel barrierefreie Zimmer buchen. Ruf einfach unser Service-Center an: "}<a className="text-link" href={`tel:+49${servicePhone}`}>{servicePhone}</a>.</Accordion>;
    $[5] = servicePhone;
    $[6] = showBarrierFreeInfo;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="flex flex-col gap-6">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(t0) {
  const {
    key
  } = t0;
  return key === "Accessible";
}